import React from 'react';
import styled from 'styled-components';
import VenueColumnInfo from './component/venues/VenueColumnInfo';
import VenueList from './component/venues/VenueList';
import VenueMetaStation from './component/venues/VenueMetaStation';
import PageAboutVenue from './component/venues/PageAboutVenue';

const AdminVenues: React.FC = () => (
  <VenueContainer>
    <VenueMetaStation />
    <VenueColumnInfo />
    <VenueList />
    <PageAboutVenue />
  </VenueContainer>
);

const VenueContainer = styled.main`
  width: 96%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  margin-top: calc(8vh);
  margin-bottom: 5.8vh ;
  overflow: hidden;
`;

export default AdminVenues;
